import React, { useState } from "react";
import { useSelector } from "react-redux";
import "./Qualifications.css";
import CvDownloadDropdown from "../cvDownload/CvDownloadDropdown.jsx";

function Qualifications() {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const es_en = useSelector((state) => state.translation);

  return (
    <section className="qualifications section reveal" id="qualifications">
      <h2 className="section__title">
        {es_en
          ? "Studies and Work experience"
          : "Estudios y Experiencia laboral"}
      </h2>
      <span className="section__subtitle">
        {es_en ? "My personal journey" : "Mi formación personal "}
      </span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          <div
            className={
              toggleState === 1
                ? "qualification__button qualification__active button--flex"
                : "qualification__button  button--flex"
            }
            onClick={() => toggleTab(1)}
          >
            <i className="uil uil-graduation-cap qualification__icon"></i>
            {es_en ? "Education" : "Estudios"}
          </div>
          <hr />

          <div
            className={
              toggleState === 2
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
            }
            onClick={() => toggleTab(2)}
          >
            <i className="uil uil-briefcase-alt qualification__icon"></i>
            {es_en ? "Experience" : "Experiencia"}
          </div>
        </div>

        <div className="qualification__sections">
          <div
            className={
              toggleState === 1
                ? "qualification__content qualification__content-active"
                : "qualification__content "
            }
          >
            {/* SOY HENRY */}
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">
                  <a
                    href="https://www.soyhenry.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    SOY HENRY
                  </a>
                </h3>
                <span className="qualification__subtitle">
                  {es_en
                    ? "Fullstack Developer · Buenos Aires, Argentina"
                    : "Desarrollador Fullstack · Buenos Aires, Argentina"}
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>2021
                </div>
                <br />
                <a
                  href="https://certificates.soyhenry.com/cert?id=cebb7a86-2827-484a-83ca-88ffd3fbcd49"
                  target="_blank"
                  rel="noreferrer"
                >
                  {es_en ? "Certificate" : "Certificado"}
                </a>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            {/* Instituto Universitario */}
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">
                  {es_en
                    ? "Institute of Administration & Management"
                    : "Instituto de Administración y Gerencia"}
                </h3>
                <span className="qualification__subtitle">
                  {es_en
                    ? "Administration & Financial Management (equiv. FP) · Caracas"
                    : "Administración y Gerencia Financiera (Equiv. FP) · Caracas"}
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>2016
                </div>
              </div>
            </div>

            {/* Está comentado por razones propias */}
            {/** Universidad Alejandro Humboldt
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">
                  {es_en
                    ? "Universidad Alejandro Humboldt"
                    : "Universidad Alejandro Humboldt"}
                </h3>
                <span className="qualification__subtitle">
                  {es_en
                    ? "Bachelor's Degree in Economics · Caracas, Venezuela"
                    : "Licenciatura en Economía · Caracas, Venezuela"}
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>2009
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            */}

            {/* OXCAM CENTER */}
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
              </div>
              <div>
                <h3 className="qualification__title">OXCAM CENTER</h3>
                <span className="qualification__subtitle">
                  {es_en
                    ? "Effective Negotiation – Harvard Method · Caracas"
                    : "Negociación Efectiva, Método Harvard · Caracas"}
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>2016
                </div>
              </div>
            </div>
          </div>

          {/* Experience */}

          <div
            className={
              toggleState === 2
                ? "qualification__content qualification__content-active"
                : "qualification__content "
            }
          >
            {/* Freelance */}
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Freelance</h3>
                <span className="qualification__subtitle">
                  {es_en
                    ? "Freelance | Senior Full Stack Developer IA · Madrid, Spain · Remote"
                    : "Freelance | Senior Full Stack Developer IA · Madrid, España · Remoto"}
                </span>
                <ul className="qualification__metrics">
                  <li>
                    {es_en
                      ? "AI Orchestration: Design of end-to-end architectures optimized with Orion OS and GitHub MCP. Core Dev: Development of scalable applications with Angular 21 (Signals) and NestJS. Automation: Process automation using Python and integration of automatic Quality Gates in CI/CD."
                      : "AI Orchestration: Diseño de arquitecturas end-to-end optimizadas con Orion OS y GitHub MCP. Core Dev: Desarrollo de aplicaciones escalables con Angular 21 (Signals) y NestJS. Automation: Automatización de procesos mediante Python e integración de Quality Gates automáticos en CI/CD."}
                  </li>
                </ul>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>
                  {es_en ? "Jan 2026 - Present" : "Ene 2026 - Actualidad"}
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            {/* IBM */}
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">IBM</h3>
                <span className="qualification__subtitle">
                  {es_en
                    ? "Full-Stack Web Developer · Madrid, Spain"
                    : "Full-Stack Web Developer · Madrid, España"}
                </span>
                <ul className="qualification__metrics">
                  <li>
                    {es_en
                      ? "Built high-traffic customer service widgets for Orange, Banco Santander and El Corte Inglés, integrating AI services with Angular (v14–17), Node.js, TypeORM and PostgreSQL."
                      : "Construí widgets de atención al cliente de alto tráfico para Orange, Banco Santander y El Corte Inglés, integrando servicios de IA con Angular (v14–17), Node.js, TypeORM y PostgreSQL."}
                  </li>
                  <li>
                    {es_en
                      ? "Created a Python script that reduced .xlf translation file updates from 2 hours to seconds."
                      : "Creé un script en Python que redujo la actualización de archivos .xlf de 2 horas a segundos."}
                  </li>
                  <li>
                    {es_en
                      ? "Led DevOps work at El Corte Inglés, provisioning environments and automating CI/CD pipelines with Kubernetes, Docker and GitHub Actions."
                      : "Lideré tareas DevOps en El Corte Inglés, configurando entornos y automatizando pipelines CI/CD con Kubernetes, Docker y GitHub Actions."}
                  </li>
                </ul>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>
                  {es_en ? "Oct 2023 - Jan 2026" : "Oct 2023 - Ene 2026"}
                </div>
              </div>
            </div>

            {/* Elecnor */}
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Elecnor</h3>
                <span className="qualification__subtitle">
                  {es_en
                    ? "Full-Stack Web Developer · Madrid, Spain"
                    : "Full-Stack Web Developer · Madrid, España"}
                </span>
                <ul className="qualification__metrics">
                  <li>
                    {es_en
                      ? "Developed core modules for an energy trading ERP serving 1,000+ clients with Angular and TypeScript."
                      : "Desarrollé módulos clave para un ERP de gestión de bolsa energética con Angular y TypeScript, utilizado por más de 1.000 clientes."}
                  </li>
                  <li>
                    {es_en
                      ? "Built a real-time monitoring dashboard from scratch for 1,000+ concurrent users across 4 distributed nodes using React, Redux and Java/Spring Boot/MongoDB microservices."
                      : "Construí desde cero un dashboard de monitorización en tiempo real para más de 1.000 usuarios concurrentes y 4 nodos distribuidos, con React, Redux y microservicios Java/Spring Boot/MongoDB."}
                  </li>
                  <li>
                    {es_en
                      ? "Integrated REST APIs and coordinated data contract synchronization with C# backend services."
                      : "Integré APIs REST y coordiné la sincronización de contratos de datos con servicios backend en C#."}
                  </li>
                </ul>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>
                  {es_en ? "Apr 2023 - Sep 2023" : "Abr 2023 - Sep 2023"}
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            {/* SOTEC */}
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">SOTEC</h3>
                <span className="qualification__subtitle">
                  {es_en
                    ? "Full-Stack Web Developer · Buenos Aires, Argentina"
                    : "Full-Stack Web Developer · Buenos Aires, Argentina"}
                </span>
                <ul className="qualification__metrics">
                  <li>
                    {es_en
                      ? "Developed e-commerce platform features with React and Express.js, including dynamic form generation and analytics dashboards using MySQL and C#."
                      : "Desarrollé funcionalidades para una plataforma de e-commerce con React y Express.js, incluyendo generación dinámica de formularios y dashboards analíticos con MySQL y C#."}
                  </li>
                </ul>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>
                  {es_en ? "May 2022 - Mar 2023" : "May 2022 - Mar 2023"}
                </div>
              </div>
            </div>

            {/* Henry Bootcamp */}
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Henry Bootcamp</h3>
                <span className="qualification__subtitle">
                  {es_en
                    ? "Teaching Assistant · Remote · Part-time"
                    : "Asistente docente · Remoto · Jornada parcial"}
                </span>
                <ul className="qualification__metrics">
                  <li>
                    {es_en
                      ? "Mentored 20+ aspiring software developers in Full Stack fundamentals (JavaScript, React, Node.js, SQL) and algorithm problem-solving."
                      : "Brindé mentoría técnica a más de 20 aspirantes a desarrolladores en fundamentos Full Stack (JavaScript, React, Node.js, SQL) y resolución de algoritmos."}
                  </li>
                </ul>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>
                  {es_en ? "Jun 2022 - Jul 2022" : "Jun 2022 - Jul 2022"}
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            {/* CRAP */}
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">CRAP</h3>
                <span className="qualification__subtitle">
                  {es_en
                    ? "Analyst / Functional Developer · Buenos Aires, Argentina"
                    : "Analista / Desarrollador Funcional · Buenos Aires, Argentina"}
                </span>
                <ul className="qualification__metrics">
                  <li>
                    {es_en
                      ? "Automated 8 financial reporting processes with VBA macros, saving 20 h/month"
                      : "Automaticé 8 procesos de informes financieros con macros VBA, ahorrando 20 h/mes"}
                  </li>
                </ul>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>
                  {es_en ? "Nov 2018 - May 2022" : "Nov 2018 - May 2022"}
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            {/* CENCOEX */}
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
              </div>
              <div>
                <h3 className="qualification__title">CENCOEX</h3>
                <span className="qualification__subtitle">
                  {es_en
                    ? "Process Analyst & Developer · Caracas, Venezuela"
                    : "Analista y Desarrollador de Procesos · Caracas, Venezuela"}
                </span>
                <ul className="qualification__metrics">
                  <li>
                    {es_en
                      ? "Digitised and automated 15 administrative processes, reducing processing time by 60%"
                      : "Digitalicé y automaticé 15 procesos administrativos, reduciendo el tiempo de gestión un 60%"}
                  </li>
                </ul>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>
                  {es_en ? "Jan 2015 - Jan 2018" : "Ene 2015 - Ene 2018"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="qualification__download">
        <CvDownloadDropdown isEnglish={es_en} />
      </div>
    </section>
  );
}

export default Qualifications;
